export const emojiMap: Record<string, string> = {
    '[微笑]': '😃',
    '[无语]': '😶',
    '[亲亲]': '😘',
    '[难过]': '☹️',
    '[愉快]': '😊',
    '[鄙视]': '🙄',
    '[调皮]': '😉',
    '[发呆]': '😐',
    '[笑哭]': '😂',
    '[委屈]': '😢',
    '[色]': '😍',
    '[冷汗]': '😅',
    '[闭嘴]': '😑',
    '[恐惧]': '😱',
    '[害羞]': '😳',
    '[生气]': '😤',
    '[撇嘴]': '😖',
    '[睡觉]': '😴',
    '[酷]': '😎',
    '[晕]': '😵',
    '[大哭]': '😭',
    '[开心]': '😊',
    '[吃惊]': '😬',
    '[感冒]': '😷',
    '[偷笑]': '🙈',
    '[不忍直视]': '🙊',
    '[哦买噶]': '🙉',
    '[骷髅]': '💀',
    '[憨笑]': '😸',
    '[呵呵]': '😹',
    '[玫瑰]': '🌹',
    '[咖啡]': '☕',
    '[庆祝]': '🎉',
    '[干杯]': '🍻',
    '[爱心]': '💖',
    '[火箭]': '🚀',
    '[公告]': '📢',
    '[红旗]': '🚩',
    '[晚安]': '🌃',
    '[早]': '🌅',
    '[赞]': '👍',
    '[OK]': '👌',
    '[再见]': '👋',
    '[祈祷]': '🙏',
    '[鼓掌]': '🙌',
    '[皇冠]': '👑',
    '[棒棒糖]': '🍭',
    '[太阳]': '🌞',
    '[星星]': '🌟',
    '[礼物]': '🎁',
    '[行情]': '📊',
    '[上涨]': '📈',
    '[下跌]': '📉',
    '[满分]': '💯',
    '[稍等]': '⏳',
    '[警示灯]': '🚨',
    '[禁止]': '🚫',
    '[灯泡]': '💡',
    '[心碎]': '💔',
    '[偷看]': '👀'
}

export const emojiList = Object.values(emojiMap)

// 创建反向映射：从 emoji 字符映射到文本格式（用于 Windows 7 等不支持 emoji 的系统）
export const emojiToTextMap: Record<string, string> = {}
Object.entries(emojiMap).forEach(([text, emoji]) => {
    emojiToTextMap[emoji] = text
})